import { jsxs as s, jsx as m } from "react/jsx-runtime";
import { flexRender as t } from "@tanstack/react-table";
import { SolidChevronDownIcon as u } from "../../Icons/basic/SolidChevronDownIcon.js";
import { Checkbox as i } from "../../Checkbox/index.js";
const p = ({ row: e, cell: n }) => /* @__PURE__ */ s("div", { className: "jm-flex jm-gap-5", children: [
  /* @__PURE__ */ m(
    "div",
    {
      className: `jm-transition-transform ${e.getIsExpanded() ? "" : "jm-custom-rotate-180"}`,
      children: /* @__PURE__ */ m("div", { className: "jm-flex jm-h-6 jm-w-6 jm-items-center jm-justify-center", children: /* @__PURE__ */ m(u, { size: "sm" }) })
    }
  ),
  t(n.column.columnDef.cell, n.getContext())
] }), v = ({ cell: e }) => t(e.column.columnDef.aggregatedCell, e.getContext()), N = ({
  row: e,
  isRowSelected: n,
  handleChange: l,
  isRegularSize: c,
  disabled: o
}) => /* @__PURE__ */ m("div", { className: c ? "-jm-mt-3" : "-jm-mt-2", children: /* @__PURE__ */ m(
  i,
  {
    name: e.id,
    checked: n,
    onChange: () => {
      l(e);
    },
    disabled: o
  }
) }), D = ({
  cell: e,
  row: n,
  isRowSelected: l,
  handleChange: c,
  isRegularSize: o,
  disabled: d,
  isMultipleSelectionMode: j
}) => {
  const a = e.getValue();
  return /* @__PURE__ */ s("div", { className: "jm-flex jm-w-full jm-items-center", children: [
    j && e.column.getIndex() === 0 && /* @__PURE__ */ m("div", { className: "-jm-mt-3", children: /* @__PURE__ */ m(
      i,
      {
        name: n.id,
        checked: l,
        onChange: () => {
          c(n);
        },
        disabled: d
      }
    ) }),
    Array.isArray(a) ? /* @__PURE__ */ m(
      "div",
      {
        className: `jm-flex jm-flex-1 jm-flex-col jm-justify-center ${o ? "jm-gap-6" : "jm-gap-4"}`,
        children: a.map((r, f) => /* @__PURE__ */ m("div", { className: "jm-flex jm-h-6 jm-items-center", children: t(e.column.columnDef.cell, {
          ...e.getContext(),
          getValue: () => r,
          renderValue: () => r
        }) }, f))
      }
    ) : t(e.column.columnDef.cell, e.getContext())
  ] });
};
export {
  v as AggregatedCell,
  D as DefaultCell,
  p as GroupedCell,
  N as GroupedCheckboxCell
};
//# sourceMappingURL=Cell.js.map
